// 音声処理
import common from '@/mixin/common'
import * as constants from '@/mixin/constants'

export default {
  data () {
    return {
      myAudio: null,
      isAudioPlaying: false, // Audio再生中かを判断するフラグ
    }
  },
  mixins: [
    common,
  ],
  created() {
    this.log("audio start created");

    this.myAudio = new Audio();
  },
  destroyed () {
    this.log("audio start destroyed");

    if(this.myAudio != null) {
      this.audioPause()
      this.myAudio = null
    }
  },
  methods: {
    // 音声再生
    audioPlay: function(audioPath) {
      this.log("audio start audioPlay");
      const self = this;

      // 再生中の場合は、停止する
      if(!this.myAudio.paused) {
        this.myAudio.pause();
      }

      // 再生
      this.myAudio.src = audioPath;
      this.myAudio.load();
      this.myAudio.play();
      this.isAudioPlaying = true;

      // 再生が終了した場合
      this.myAudio.onended = function() {
        self.log("audio end audioPlay");
        self.isAudioPlaying = false;
      }
    },

    // 音声停止
    audioPause: function() {
      this.log("audio start audioPause");

      if(this.myAudio == null) {
        return
      }

      if(!this.myAudio.paused) {
        this.myAudio.pause();
        this.isAudioPlaying = false;
      }
    },

    // 正解音の再生
    audioCorrect: function() {
      this.log("audio start audioCorrect");
      if (this.$store.getters.answerSound == "true") {
        this.audioPlay(constants.AUDIO_CORRECT);
      }
    },

    // 不正解音の再生
    audioInCorrect: function() {
      this.log("audio start audioInCorrect");
      if (this.$store.getters.answerSound == "true") {
        this.audioPlay(constants.AUDIO_INCORRECT);
      }
    },

    // 音声認識再生音の再生
    audioRecognition: function() {
      this.log("audio start audioRecognition");

      this.audioPlay(constants.AUDIO_RECOGNITION);
    },

    // マスク音の再生
    audioMask: function() {
      this.log("audio start audioMask");

      this.audioPlay(constants.AUDIO_MASK);
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixin/audio.js